export default __webpack_public_path__ + "static/media/home.985a92cf.svg";